const routeAdmin = () => '/telegram-users';

export default routeAdmin;